module.exports = __webpack_public_path__ + "img/BIT_white35.0635d1e2.jpg";